import { BEGIN_OPTIMISTIC_UPDATE, COMMIT_OPTIMISTIC_UPDATE, REVERT_OPTIMISTIC_UPDATE } from '../../optimistic.update.reducer';

export const CSW_RATE_ACTION_SUCCESS = 'CSW_RATE_ACTION_SUCCESS';
export const CSW_RATE_ACTION_FAILURE = 'CSW_RATE_ACTION_FAILURE';

export const makeOptimisticMeta = (fulfillmentPlanId, optimisticId) => {
  return {
    optimistic: BEGIN_OPTIMISTIC_UPDATE,
    optimisticId,
    onSuccess: () => ({
      type: CSW_RATE_ACTION_SUCCESS,
      payload: { fulfillmentPlanId },
      meta: {
        optimistic: COMMIT_OPTIMISTIC_UPDATE,
        optimisticId,
      },
    }),
    onError: (error) => ({
      type: CSW_RATE_ACTION_FAILURE,
      payload: { fulfillmentPlanId, error: new Error(error) },
      meta: {
        optimistic: REVERT_OPTIMISTIC_UPDATE,
        optimisticId,
        error: true,
      },
    }),
  };
};
